import {
  api_portalOfficeListing_filter,
  ibow2_proto_PortalOfficeListingService,
} from '@/init/swagger';
import { CreateListingType } from '@/schemas/CreateListingSchema';
import { LISTING_FILTER_CATEGORY_TYPE } from '@/types/types';

type MasterProps = {
  masterItems: api_portalOfficeListing_filter[];
};

export const assortMasterServiceItems = ({ masterItems }: MasterProps) => {
  const initialValue: {
    services: typeof masterItems;
    medicalCares: typeof masterItems;
    certifications: typeof masterItems;
    additionStatuses: typeof masterItems;
    appealPoints: typeof masterItems;
    others: typeof masterItems;
  } = {
    services: [],
    medicalCares: [],
    certifications: [],
    additionStatuses: [],
    appealPoints: [],
    others: [],
  };

  return masterItems.reduce((result, value) => {
    switch (value.category_id) {
      case LISTING_FILTER_CATEGORY_TYPE.SERVICE:
        result.services.push(value);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.MEDICAL_CARE:
        result.medicalCares.push(value);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.CERTIFICATION:
        result.certifications.push(value);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.ADDITION_STATUS:
        result.additionStatuses.push(value);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.APPEAL_POINTS:
        result.appealPoints.push(value);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.OTHERS:
        result.others.push(value);
        break;
      default:
        break;
    }
    return result;
  }, initialValue);
};

type Props = {
  items:
    | CreateListingType['portal_office_listing']['portal_office_listing_services']
    | ibow2_proto_PortalOfficeListingService[];
  masterItems: api_portalOfficeListing_filter[];
};

export type InitialValueType = {
  category_id?: number | undefined;
  search_filter_id?: number | undefined;
  label: string;
}[];

export const assortServiceItems = ({ items, masterItems }: Props) => {
  const initialValue: {
    services: InitialValueType;
    medicalCares: InitialValueType;
    certifications: InitialValueType;
    additionStatuses: InitialValueType;
    appealPoints: InitialValueType;
    others: InitialValueType;
  } = {
    services: [],
    medicalCares: [],
    certifications: [],
    additionStatuses: [],
    appealPoints: [],
    others: [],
  };

  if (!items) {
    return initialValue;
  }

  return items.reduce((result, value) => {
    const label = getServiceLabel({ item: value, masterItems });
    if (!label) {
      return result;
    }
    const withLabelValue = { ...value, label };
    switch (value.category_id) {
      case LISTING_FILTER_CATEGORY_TYPE.SERVICE:
        result.services.push(withLabelValue);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.MEDICAL_CARE:
        result.medicalCares.push(withLabelValue);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.CERTIFICATION:
        result.certifications.push(withLabelValue);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.ADDITION_STATUS:
        result.additionStatuses.push(withLabelValue);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.APPEAL_POINTS:
        result.appealPoints.push(withLabelValue);
        break;
      case LISTING_FILTER_CATEGORY_TYPE.OTHERS:
        result.others.push(withLabelValue);
        break;
      default:
        break;
    }
    return result;
  }, initialValue);
};

type GetLabelProps = {
  item:
    | {
        category_id?: number;
        search_filter_id?: number;
      }
    | undefined;
  masterItems: api_portalOfficeListing_filter[];
};

const getServiceLabel = ({ item, masterItems }: GetLabelProps) => {
  if (!item) {
    return undefined;
  }

  return masterItems.find(
    (i) => i.category_id === item.category_id && i.id === item.search_filter_id,
  )?.label;
};
